// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"95bff5c2","994":"92331236"}[chunkId] + ".chunk.js";
};